const { registerBlockType } = wp.blocks; // Import registerBlockType() from wp.blocks

/**
 * Register: aa Gutenberg Block.
 *
 * Registers a new block provided a unique name and an object defining its
 * behavior. Once registered, the block is made editor as an option to any
 * editor interface where blocks are implemented.
 *
 * @link https://wordpress.org/gutenberg/handbook/block-api/
 * @param  {string}   name     Block name.
 * @param  {Object}   settings Block settings.
 * @return {?WPBlock}          The block, if it has been successfully
 *                             registered; otherwise `undefined`.
 */

import attributes from './attributes';
import Edit from './edit';

registerBlockType('plans-tabs/block', {
  title: 'Integração Planos Tabs',
  description: 'Integração Planos Tabs',
  icon: 'money-alt',
  category: 'design',
  attributes,
  keywords: ['Integração Planos Tabs', 'Planos'],

  edit: (props) => <Edit {...props} />,
  save: function ({ attributes }) {
    return <div> </div>; //null
  },
});
